import React, { useState, useRef, useEffect } from 'react';
import { Globe, Check } from 'lucide-react';
import { LANGUAGES, useLang } from '@/lib/i18n';

// Compact language toggle (available before sign-in, on landing/onboarding/account).
export const LanguageToggle = () => {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const currentLabel = lang === 'tl' ? 'FIL' : lang === 'ceb' ? 'CEB' : 'EN';

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="language-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-label="Change language"
        className="inline-flex items-center gap-1.5 rounded-full px-3 min-h-[40px] text-sm font-semibold border"
        style={{ background: 'var(--surface)', color: 'var(--text)', borderColor: 'var(--border)' }}
      >
        <Globe size={16} /> {currentLabel}
      </button>
      {open && (
        <div className="absolute right-0 mt-1 z-50 rounded-xl border overflow-hidden min-w-[180px]" style={{ background: 'var(--surface)', borderColor: 'var(--border)', boxShadow: 'var(--shadow)' }}>
          {LANGUAGES.map((l) => (
            <button
              key={l.id}
              data-testid={`language-option-${l.id}`}
              onClick={() => { setLang(l.id); setOpen(false); }}
              className="w-full text-left px-3 py-2.5 text-sm flex items-center justify-between border-t first:border-t-0"
              style={{ borderColor: 'var(--border)', color: 'var(--text)', background: lang === l.id ? 'var(--surface-alt)' : 'var(--surface)' }}
            >
              {l.label}
              {lang === l.id && <Check size={16} style={{ color: 'var(--primary)' }} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
